module.exports = __webpack_public_path__ + "catalog/items/outdoor/rectangular-swimming-pool/rectangular-swimming-pool.svg";